/**
 * Site Content Data
 * Edit this file to update all text content on the site
 */

export const siteConfig = {
  companyName: "Citta Consulting",
  founderName: "Linda M. Mundy",
  credentials: "MD, PhD",
  email: "LindaMMundy@gmail.com",
  location: "New York, NY",
  linkedIn: "https://www.linkedin.com/in/lindammundy-mdphd/",
};

export const navigation = [
  { id: 'home', label: 'Home', type: 'page' },
  { id: 'about', label: 'About', type: 'page' },
  { id: 'services', label: 'Services', type: 'section' },
  { id: 'contact', label: 'Contact', type: 'section' },
];

export const heroContent = {
  tagline: "Executive Coaching · Mindfulness · Leadership",
  title: "Helping you be",
  titleEmphasis: "your best self",
  subtitle: "By connecting your mind, body, and purpose",
  founderHighlight: `Founded by <strong>${siteConfig.founderName}, ${siteConfig.credentials}</strong> — a physician scientist, certified executive coach, and mindfulness meditation practitioner with over three decades of experience in medicine, public health leadership, and contemplative practice.`,
  primaryCta: "Begin Your Journey",
  secondaryCta: "Our Services",
};

export const services = [
  {
    title: 'Executive & Professional Coaching',
    description: 'One-on-one coaching for executives and senior leaders navigating complex organizational challenges while maintaining authentic leadership presence.',
    features: [
      {
        activity: 'Leadership Development',
        details: '',
      },
      {
        activity: 'Strategic Decision-Making',
        details: '',
      },
      {
        activity: 'Transition Support',
        details: '',
      },
    ],
  },
  {
    title: 'Mindfulness Programs',
    description: 'Evidence-based mindfulness training for individuals and teams, grounded in contemplative traditions.',
    features: [
      {
        activity: 'Individual Mindfulness Practice', 
        details: '',
      },
      {
        activity: 'Group Mindfulness Practice',
        details: 'My next group session will begin in the fall of 2026, come back soon to learn more! ',
        // courseLink: "https://events.jhu.edu/form/SkillstoSustain-Odyssey2026", //to add
      },
    ],
  },
];

export const approach = {
  title: "Citta Consulting prioritizes the cultivation and integration of the",
  titleEmphasis: "Mind & Heart",
  description: [],
  steps: [
    // { num: '01', title: 'Identify Goals', desc: '' },
    // { num: '02', title: 'Clarify and Align Goals with Core Values', desc: '' },
    // { num: '03', title: 'Practice Noticing Incremental Changes with Progress towards goals ', desc: '' },
  ],
};

export const quote = {
  text: "Be yourself, be your best self. Dare to be different and follow your own star.",
  author: `${siteConfig.founderName}`,
};

export const contactContent = {
  title: "Let's Begin a",
  titleEmphasis: "Conversation",
  description: "Meaningful transformation starts with a single conversation. I work with a select number of clients to ensure depth and attention in every engagement. If you're ready to explore how we might work together, I welcome hearing from you.",
  interestOptions: [
    { value: '', label: 'Select...' },
    { value: 'coaching', label: 'Executive Coaching' },
    { value: 'mindfulness', label: 'Mindfulness Programs' },
    { value: 'advisory', label: 'Physician Peer Coaching' },
  ],
};

// About Page Content
export const aboutHero = {
  tagline: "About",
  title: "Meet",
  titleEmphasis: "Linda M. Mundy",
  subtitle: "Physician scientist, executive coach, and mindfulness meditation instructor dedicated to cultivating resilient, purpose-driven leaders.",
};

export const aboutBio = {
  title: "A Career Dedicated to",
  titleEmphasis: "Human and Planetary Health",
  paragraphs: [
    "Linda is excited to support your growth through executive and professional coaching during life transitions. ",
  ],
  philosophyQuote: "Be yourself, be your best self. Dare to be different and follow your own star.",
};

export const quickFacts = [
  { label: 'Based in', value: 'New York, NY' },
  { label: 'Education', value: 'MD, PhD' },
  { label: 'Focus', value: 'Leadership & Mindfulness' },
];

export const credentials = [
  {
    type: 'Certifications',
    details: [
      {
        degree: 'Executive Coach', 
        institution: 'Hudson Institute of Coaching', 
      },
      { 
        degree: 'Physician Peer Coach', 
        institution: 'American College of Physicians', 
      },
      { 
        degree: 'Mindfulness Instructor', 
        institution: 'Mindful Meditation Teacher Certification Program', 
      },
    ]
  },
  {
    type: 'Education',
    details: [
      { 
        degree: 'Doctor of Medicine (MD)', 
        institution: 'The Johns Hopkins University School of Medicine', 
      },
      { 
        degree: 'Doctor of Philosophy (PhD)', 
        institution: 'Saint Louis University, School of Public Health', 
      },
    ]
  }
];
